import { useDrag } from 'react-dnd';
import TaskItem from './TaskItem';
import { Task } from '../interfaces/Task';

interface DraggableTaskItemProps {
    task: Task;
    position: number;
    deleteCallback: CallableFunction;
    duplicateCallback: CallableFunction;
    sectionId?: string;
}

export default function DraggableTaskItem(props: DraggableTaskItemProps) {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'task',
        item: {
            taskId: props.task._id,
            currentSectionId: props.sectionId,
            task: props.task
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [props.task._id, props.sectionId]);

    return (
        <div
            ref={drag as any}
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: isDragging ? 'grabbing' : 'grab',
                zIndex: isDragging ? 1000 : 'auto',
                position: 'relative'
            }}
        >
            <TaskItem
                task={props.task}
                position={props.position}
                deleteCallback={props.deleteCallback}
                duplicateCallback={props.duplicateCallback}
            />
        </div>
    );
}